<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
import { useRouter } from 'vue-router'
import { homeCategories } from '~/resources/lobby-games/menu-category'
import { useJackPot } from '~/composables/common/use-jackpot'
import { useLighthouse } from '~/composables/common/use-lighthouse'

const router = useRouter()
const { slotsJackpot } = useJackPot()
const { isLighthouseBot } = useLighthouse()

const ProviderList = defineAsyncComponent(async () => await import('~/components/common/sport/provider-list.vue'))
const BaseButton = defineAsyncComponent(async () => await import('~common/base-button.vue'))
const AnimatedNumber = defineAsyncComponent(async () => await import('~/components/common/animated-number.vue'))
const MatchSchedule = defineAsyncComponent(async () => await import('./match-schedule.vue'))

const handleClick = (link: string): void => {
  router.push(link)
}
</script>
<template>
  <div class="game-lobby">
    <img
      v-if="isLighthouseBot"
      src="/assets/images/pages/lobby-games/the-thao-bg.webp"
      fetchpriority="high"
      loading="eager"
      preload
      alt="preload src"
      style="display: none"
    />
    <img
      v-if="isLighthouseBot"
      src="assets/images/pages/lobby-games/casino-bg.svg"
      fetchpriority="high"
      loading="eager"
      preload
      alt="preload src"
      style="display: none"
    />
    <img
      v-if="isLighthouseBot"
      src="/assets/images/pages/lobby-games/no_hu-bg.svg"
      fetchpriority="high"
      loading="eager"
      preload
      alt="preload src"
      style="display: none"
    />
    <div class="the-thao">
      <ProviderList />

      <div class="description">
        <h5>THỂ THAO</h5>
        <p>Cuồng Nhiệt Mọi Giải Đấu</p>
        <BaseButton @click="handleClick('/the-thao')">Cược ngay</BaseButton>
      </div>
      <MatchSchedule v-if="!isLighthouseBot" />
    </div>
    <div class="other-games">
      <div
        v-for="(item, index) in homeCategories"
        :key="index"
        :class="['game-item', item.className]"
        @click="handleClick(item.link)"
      >
        <div class="item-inner">
          <div class="item-title">
            <h6>{{ item.label }}</h6>
            <p>{{ item.text }}</p>
          </div>
          <img v-if="!isLighthouseBot" :src="item.imgSrc" :alt="item.label" />
        </div>
        <div v-if="index !== 0" class="jackport">
          <img src="/assets/images/pages/lobby-games/jackport.svg" alt="jackport" />
          <AnimatedNumber :number="slotsJackpot" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~scssAsset/desktop/pages/home/category.scss';
</style>
